import { useQuery } from '@tanstack/react-query';
import { getHospitalityReservationByToken } from '@/services/hospitality.service';

export const useGetReservationByToken = (
    reservationToken?: string,
    shouldFetch = true
) => {
    return useQuery({
        queryKey: ['HospitalityReservationByToken', reservationToken],
        enabled: Boolean(reservationToken) && shouldFetch,
        queryFn: async () => {
            const { reservation, error } = await getHospitalityReservationByToken(
                reservationToken!
            );

            if (error) {
                throw new Error(error);
            }

            return reservation!;
        },
        retry: false,
    });
};
